import { useEffect, useState } from 'react'

export type Countdown = {
  hours: string
  minutes: string
  seconds: string
  expired: boolean
}

const pad = (n: number) => String(Math.max(0, n)).padStart(2, '0')

/**
 * Counts down from a number of seconds. Never goes below zero.
 */
export function useCountdown(totalSeconds: number): Countdown {
  const [remaining, setRemaining] = useState(totalSeconds)

  useEffect(() => {
    setRemaining(totalSeconds)
  }, [totalSeconds])

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
    expired: remaining <= 0,
  }
}
